import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { IAction } from '../../action/IAction'
import type { AiCreditTransaction } from './AiCreditTransaction'
import type { AiCreditTransactionTotals } from './AiCreditTransactionTotals'

/**
 * Same shape as `GetAiCreditTransactionListArgs` — the owner scope rides inside `filter`
 * (`filter.ownerId`), guarded in `scopeToOwnerDebitFilter` (`ai-common`).
 */
@InputType()
export class GetAiCreditTransactionListTotalsArgs extends QueryArgs<AiCreditTransaction> {}

export interface IGetAiCreditTransactionListTotals extends IAction<
  AiCreditTransactionTotals,
  GetAiCreditTransactionListTotalsArgs
> {}
